const router = function (permissions) {
  return ({
    path: 'funcionarios',
    component: () => import('@/views/Funcionario/FuncionarioModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        component: () => import('@/views/Funcionario/FuncionarioList.vue'),
        meta: { permissions, title: 'Manutenção de Funcionários' },
      },
      {
        path: 'cadastrar',
        component: () => import('@/views/Funcionario/FuncionarioProfile.vue'),
        meta: { permissions, title: 'Cadastrando Funcionário' },
      },
      {
        path: 'alterar',
        component: () => import('@/views/Funcionario/FuncionarioProfile.vue'),
        meta: { permissions, title: 'Editando Funcionário' },
      },
    ],
  })
}

export default {
  router,
}
